import { useState, useEffect } from "react";

// hooks
import { useRedux } from "./useRedux";

// api
import {
  getLoggedinUser,
  getLoggedinUserCompanyName,
  getLoggedinUserName,
} from "../api/apiCore";
import { createSelector } from "reselect";
//utils
import { divideByKey } from "../utils";
import Cookies from "js-cookie";
import logger from "../utils/logger";

interface LoginResponse {
  companyName: string;
  userName: string;
}

const useProfile = () => {
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState<LoginResponse | null>(null);

  useEffect(() => {
    const userName = getLoggedinUserName();
    const companyName = getLoggedinUserCompanyName();

    // Check if we have basic auth info (for onboarding access)
    // Allow access if we have userName (companyName can be empty for onboarding)
    if (userName) {
      setUserProfile({
        companyName: companyName || "", // Allow empty companyName for onboarding
        userName,
      });
    } else {
      // Fallback: check localStorage for user data (for newly registered users)
      const authUser = localStorage.getItem("authUser");
      if (authUser) {
        try {
          const userData = JSON.parse(authUser);
          if (userData.id && (userData.name || userData.firstName)) {
            // Set minimal profile to allow onboarding access
            const name =
              userData.name ||
              `${userData.firstName} ${userData.lastName}`.trim();
            setUserProfile({
              companyName: userData.companyName || "",
              userName: name,
            });
          } else {
            setUserProfile(null);
          }
        } catch (e) {
          logger.error("Error parsing auth user data:", e);
          setUserProfile(null);
        }
      } else {
        setUserProfile(null);
      }
    }
    setLoading(false);
  }, []);

  return { userProfile, loading };
};

const useContacts = () => {
  // global store
  const { useAppSelector } = useRedux();

  // const { contactsList } = useAppSelector(state => ({
  //   contactsList: state.Contacts.contacts,
  // }));

  const errorData = createSelector(
    (state: any) => state.Contacts,
    (state) => ({
      contactsList: state.contacts,
    }),
  );
  // Inside your component
  const { contactsList } = useAppSelector(errorData);

  const [contacts, setContacts] = useState<Array<any>>([]);
  const [categorizedContacts, setCategorizedContacts] = useState<Array<any>>(
    [],
  );
  useEffect(() => {
    if (contactsList.length > 0) {
      setContacts(contactsList);
    }
  }, [contactsList]);

  useEffect(() => {
    if (contacts.length > 0) {
      const formattedContacts = divideByKey("firstName", contacts);
      setCategorizedContacts(formattedContacts);
    }
  }, [contacts]);

  const totalContacts = (categorizedContacts || []).length;
  return { categorizedContacts, totalContacts };
};

const useConversationUserType = () => {
  // global store
  const { useAppSelector } = useRedux();

  // const { chatUserDetails } = useAppSelector(state => ({
  //   chatUserDetails: state.Chats.chatUserDetails,
  // }));

  const errorData = createSelector(
    (state: any) => state.Chats,
    (state) => ({
      chatUserDetails: state.chatUserDetails,
    }),
  );
  // Inside your component
  const { chatUserDetails } = useAppSelector(errorData);

  const [isChannel, setIsChannel] = useState<boolean>(false);
  useEffect(() => {
    setIsChannel(chatUserDetails.isChannel ? true : false);
  }, [chatUserDetails]);

  return { isChannel };
};
export { useProfile, useContacts, useConversationUserType };
